<template>
  <div class="intro">
    <div id="image">
      <img src="/hielera_los_hermanos_transparent.PNG" alt="Logo" />
    </div>
    <div id="info">
      <h2>La Diferencia Los Hermanos</h2>
      <p class="simple_p">
        Ser líderes en el campo mediante la innovación en manufactura y distribución
        de hielo en Puerto Rico y servicio al cliente.
      </p>
      <p style="padding: 0; margin: 0;">
        Contactos:
        <ul id="contact">
          <li>Tel: <a class="contact" href="tel:+19393493000">939-349-3000</a></li>
          <li>Email: <a class="contact" href="mailto:hieleraloshermanosrivera@gmail.com">hieleraloshermanosrivera@gmail.com</a></li>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroSection'
}
</script>
